import { render, staticRenderFns } from "./MonitorVideo.vue?vue&type=template&id=cf22107a&scoped=true&"
import script from "./MonitorVideo.vue?vue&type=script&lang=js&"
export * from "./MonitorVideo.vue?vue&type=script&lang=js&"
import style0 from "./MonitorVideo.vue?vue&type=style&index=0&id=cf22107a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf22107a",
  null
  
)

export default component.exports